import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
  Box,
} from "@mui/material";

/**
 * A reusable confirmation dialog component.
 *
 * @param {object} props - Component props.
 * @param {boolean} props.open - Controls the visibility of the modal.
 * @param {string} props.title - The title of the modal.
 * @param {string} props.message - The main content/message of the modal.
 * @param {Function} props.onClose - Function to call when the modal is closed (e.g., on cancel).
 * @param {Function} props.onConfirm - Function to call when the user confirms the action.
 * @param {boolean} [props.loading=false] - Optional prop to show a loading spinner on the confirm button.
 * @param {string} [props.confirmText="Confirm"] - Optional custom text for the confirm button.
 * @param {string} [props.cancelText="Cancel"] - Optional custom text for the cancel button.
 */
const ConfirmationModal = ({
  open,
  title,
  message,
  onClose,
  onConfirm,
  loading = false,
  confirmText = "Confirm",
  cancelText = "Cancel",
}) => {
  const handleConfirm = () => {
    onConfirm();
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading} style={{ color: "#ED141F" }}>
          {cancelText}
        </Button>
        <Button
          onClick={handleConfirm}
          disabled={loading}
          color="primary"
          variant="contained"
          style={{ background: "#ED141F" }}
        >
          {loading ? <CircularProgress size={24} /> : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
